module.exports = __webpack_public_path__ + "img/weChat_miniPrograms.596e7ae3.jpg";